// @ts-nocheck
import { Component, Suspense } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { find } from 'lodash'
import { css, StyleSheet } from 'aphrodite/no-important'
import Modal from './index'
import PopupModal from './PopupModal'
import Field from '../fields'

export class DocumentModal extends Component {
  componentDidUpdate(prevProps) {
    const { fetchList, listId } = this.props
    if (!prevProps.listId && listId) {
      fetchList(LIST_MAP[listId])
    }
  }

  handleSubmit = () => {
    const {
      fetchList,
      fields,
      listId,
      createItem,
      type,
      updateItem,
      showToast,
      onComplete
    } = this.props

    const url =
      type === 'edit' ? `list/${listId}/${fields.id}` : `list/${listId}`

    const chosenFunc = type === 'edit' ? updateItem : createItem
    chosenFunc({
      url,
      onComplete: (document) => {
        const toastTitle =
          type === 'edit' ? 'Updated a Document' : 'Added a Document'
        showToast({ title: toastTitle })
        fetchList(listId)
        onComplete?.(document)
      }
    })
  }

  render() {
    const {
      documentCategories,
      fields,
      files,
      homeDocumentCategories,
      listId,
      isOpen,
      type,
      ...formProps
    } = this.props

    if (!isOpen || !type || (!documentCategories && !homeDocumentCategories)) {
      return null
    }

    const categories =
      listId === 'documents' ? documentCategories : homeDocumentCategories

    // TODO: set subCategory to null if the category changes
    // Otherwise it'll presist
    const selectedCategory = find(categories, { id: fields.category })
    const subCatOptions =
      selectedCategory &&
      selectedCategory.subCategories &&
      selectedCategory.subCategories.map((name) => ({
        value: name,
        label: name
      }))

    return (
      <PopupModal
        confirmText={type === 'edit' ? 'Save' : 'Add'}
        buttonIcon={type !== 'edit' && 'PlusOutlined'}
        buttonColour="success"
        list={TITLE_MAP[listId]}
        includesRequired
        onConfirm={this.handleSubmit}
        style={styles.modal}
        type={type}
        {...formProps}
      >
        <div className={css(classes.fieldContainer)}>
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              formId={MODAL_ID}
              keys="name"
              label="Document Title"
              required
              type="text"
              values={fields}
            />
          </Suspense>
        </div>
        <div className={css(classes.fieldContainer)}>
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              formId={MODAL_ID}
              keys="category"
              label="Category"
              options={
                listId === 'documents'
                  ? documentCategories
                  : homeDocumentCategories
              }
              required
              type="select"
              values={fields}
            />
          </Suspense>
        </div>
        {selectedCategory && selectedCategory.subCategories && (
          <div className={css(classes.fieldContainer)}>
            <Suspense fallback={<div>Loading...</div>}>
              <Field
                formId={MODAL_ID}
                keys="subCategory"
                label="Sub-category"
                // dependsOnKey="category"
                options={subCatOptions}
                type="select"
                values={fields}
              />
            </Suspense>
          </div>
        )}
        <div className={css(classes.fieldContainer)}>
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              formId={MODAL_ID}
              keys="pdf"
              label="Document"
              required
              type="file"
              values={files}
            />
          </Suspense>
        </div>
      </PopupModal>
    )
  }
}

const classes = StyleSheet.create({
  fieldContainer: {
    marginBottom: 20,
    [`@media (min-width: 650px)`]: {
      minWidth: 540
    }
  }
})

const styles = {
  modal: {
    overflow: 'visible'
  }
}

const MODAL_ID = 'documentModal'
const LIST_MAP = {
  documents: 'document-categories',
  'home-documents': 'home-document-categories'
}
const TITLE_MAP = {
  documents: 'Document',
  'home-documents': 'Home Document'
}

DocumentModal.propTypes = {
  documentCategories: PropTypes.array,
  homeDocumentCategories: PropTypes.array,
  type: PropTypes.oneOf(['create', 'edit'])
}

const mapStateToProps = (state) => ({
  documentCategories: state.data['document-categories'],
  homeDocumentCategories: state.data['home-document-categories']
})

const wrappedModal = connect(mapStateToProps, null)(DocumentModal)

export default Modal(wrappedModal, MODAL_ID)
